import { BrowserRouter } from 'react-router-dom';
import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { SnackbarProvider } from 'notistack';

import theme from 'assets';

import 'helpers/Extensions';

import { AxiosInterceptors } from 'components';
import { ApplicationUserProvider, AuthProvider } from 'helpers/services';

import { Routes } from 'components';
import { CssBaseline } from '@material-ui/core';


let App = () => {
    return (
        <ThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <SnackbarProvider preventDuplicate>
                    <CssBaseline />
                    <BrowserRouter>
                        <AuthProvider>
                            <AxiosInterceptors />
                            <ApplicationUserProvider>
                                <Routes />
                            </ApplicationUserProvider>
                        </AuthProvider>
                    </BrowserRouter>
                </SnackbarProvider>
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    );
};

export default App;